// eslint-disable-next-line 
import util from 'util';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';

import * as MuiCore from '@material-ui/core';

/*
 * Show busy model when executing critical functions
 * 
 */

import * as coreSelectors from './selectors';

const styles = theme => ({
  dialogContent: {
    padding: '40px !important',
  }
});

class BusyBox extends Component {
  render() {
    // eslint-disable-next-line     
    const { classes, busyOpen, busyMessage } = this.props;
    
    return (
      <MuiCore.Dialog open={busyOpen}>
        <MuiCore.DialogContent className={classes.dialogContent}>
          <MuiCore.Grid container spacing={3} alignItems='center'>
            <MuiCore.Grid item>
              <MuiCore.CircularProgress color='secondary'
                                        size={60}/>
            </MuiCore.Grid>
            <MuiCore.Grid item>
              <MuiCore.Typography variant='h6'>{busyMessage}</MuiCore.Typography>
            </MuiCore.Grid>
          </MuiCore.Grid>
        </MuiCore.DialogContent>
      </MuiCore.Dialog>
    );
  }
}

const mapStateToProps = (state) => {
  return({ 
    busyOpen : coreSelectors.getBusyOpen(state),
    busyMessage : coreSelectors.getBusyMessage(state),
  });
};

const mapDispatchToProps = {
};


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(BusyBox));
